import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { IGetAddExam } from '../models/action/exam';
import { ApiTypes } from '../models/enums/ApiTypes';

let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();
const _logger = Log.create('Exam-Session-Service');

export class ExamSessionService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetExamSessionListAsync(params: any) {
        let endPoint = `api/examsession/list/${params.activityId}?courseId=${params.courseId}&classId=${params.classId}`;
        if (params.selectedExamSessionId) {
            endPoint +=  `&selectedExamSessionId=${params.selectedExamSessionId}`;
        }

        return _apiClient.RequestAsync('GET', endPoint, null, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionSelectedAsync(params: any) {
        return _apiClient.RequestAsync('GET', `api/examsession/selected/${params.examSessionId}?courseId=${params.courseId}&classId=${params.classId}`, null, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionAddAsync(params: any) {
        let endPoint = 'api/examsession/add';
        if (params.examSessionId) {
            endPoint = 'api/examsession/edit';
        }

        return _apiClient.RequestAsync('POST', endPoint, params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionAddQuestionAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/addquestions', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionDeleteQuestionAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/deletequestions', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionQuestionListsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/viewquestions', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionAddStudentListsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/getstudents', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionAddStudentAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/addstudents', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionGetStudentAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/getstudentsbytextlist', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionStudentListsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/viewstudents', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionDeleteStudentAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/deletestudents', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionPublishDatasAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/publishdatas', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionPublishAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/background/exampopulate', params, '', false, ApiTypes.Background)
        //return _apiClient.RequestAsync('POST', 'api/examsession/publish', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetExamSessionUnpublishAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/examsession/unpublish', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
}